import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast.component.css',
})
export class ToastComponent {
  readonly toastService = inject(ToastService);

  getToastClass(classname?: string): string {
    const kind = classname || '';
    if (kind.includes('bg-success')) {
      return 'border-emerald-200 bg-emerald-50 text-emerald-800';
    }
    if (kind.includes('bg-danger')) {
      return 'border-red-200 bg-red-50 text-red-800';
    }
    if (kind.includes('bg-warning')) {
      return 'border-amber-200 bg-amber-50 text-amber-900';
    }
    return 'border-slate-200 bg-white text-slate-800';
  }
}
